import { render, staticRenderFns } from "./CollegeItemList.vue?vue&type=template&id=016f0339&scoped=true"
import script from "./CollegeItemList.vue?vue&type=script&lang=js"
export * from "./CollegeItemList.vue?vue&type=script&lang=js"
import style0 from "./CollegeItemList.vue?vue&type=style&index=0&id=016f0339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f0339",
  null
  
)

export default component.exports